import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core'

const storefrontLink = createHttpLink({
  uri: GM_STATE.apis.graphQlEndpoint,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Shopify-Storefront-Access-Token': GM_STATE.apis.storefrontAccessToken
  }
})

export const storefront = new ApolloClient({
  link: storefrontLink,
  cache: new InMemoryCache()
})
